import React, { useState } from 'react';
import { SentTextIcon, NoteBookIcon, PhoneIcon } from "../../../assets"
import { Grid, Fab, Hidden } from '@material-ui/core';
import ActionButton from '../../../components/buttonsComponent/ActionButton';
import CallModal from "../Modal"
// entities
import { CampaignContact } from '../../../entities/site';
import { Actions } from '../NextAction';

interface PropsType {
  contact: CampaignContact;
  onAction(action: Actions, actionText: string): void;
}

const buttonStyle = { padding: "13px 0" }
const fabStyle = { backgroundColor: "#00ABCA" }


const ContactActions: React.FC<PropsType> = (props) => {

  const { contact, onAction } = props;
  const [isPopupOpen, setPopupOpen] = useState<boolean>(false);
  const [action, setAction] = useState<Actions>(Actions.call);
  const [title, setTitle] = useState<string>("New Call");

  const handleCallCallback = async (actionText: string) => {
    if (!contact) {
      return;
    }
    setPopupOpen(false);
    onAction(action, actionText);
  }

  const handleCloseModal = () => {
    setPopupOpen(false)
  }

  const openPopup = (currentAction: Actions) => {
    if (currentAction === Actions.call) {
      setTitle("Save & New Call");
      setAction(Actions.call)
    }
    if (currentAction === Actions.note) {
      setTitle("Add Note");
      setAction(Actions.note)
    }
    if (currentAction === Actions.text) {
      setTitle("Send Text");
      setAction(Actions.text)
    }
    setPopupOpen(true)
  }

  return (
    <>
      <Hidden only={['sm', 'md', 'lg', 'xl']}>
        <>
          <Fab
            size="small"
            aria-label="add"
            style={fabStyle}
            onClick={() => openPopup(Actions.call)}
          >
            <PhoneIcon />
          </Fab>
          <Fab
            size="small"
            aria-label="add"
            style={fabStyle}
            onClick={() => openPopup(Actions.text)}
          >
            <SentTextIcon />
          </Fab>
          <Fab
            size="small"
            aria-label="add"
            style={fabStyle}
            onClick={() => openPopup(Actions.note)}
          >
            <NoteBookIcon />
          </Fab>
        </>
      </Hidden>
      <Hidden xsDown>
        <Grid container lg={12} spacing={1} alignItems='center'>
          <Grid item lg={4} sm={12} xs={12}>
            <ActionButton size="small" onClick={() => openPopup(Actions.call)} fullWidth style={buttonStyle}>
              <PhoneIcon /> &nbsp;&nbsp;&nbsp;
              New Call
            </ActionButton>
          </Grid>
          <Grid item lg={4} sm={12} xs={12}>
            <ActionButton onClick={() => openPopup(Actions.text)} fullWidth style={buttonStyle}>
              <SentTextIcon /> &nbsp;&nbsp;&nbsp;
              Send Text
            </ActionButton>
          </Grid>
          <Grid item lg={4} sm={12} xs={12}>
            <ActionButton onClick={() => openPopup(Actions.note)} fullWidth style={buttonStyle}>
              <NoteBookIcon /> &nbsp;&nbsp;&nbsp;
              Add Note
            </ActionButton>
          </Grid>
        </Grid>
      </Hidden>

      <CallModal
        open={isPopupOpen}
        contact={contact}
        title={title}
        action={action}
        primaryActionCallback={handleCallCallback}
        onClose={handleCloseModal}
      />
    </>
  )
}

export default ContactActions



// WEBPACK FOOTER //
// ./src/pages/next-action/contactInfo/contactActions.tsx